import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AuthenticationService } from 'app/services/authentication.service';
import { LocationService } from 'app/services/location.service';
import { catchError } from 'rxjs';

@Component({
	selector: 'login-reset-password',
	templateUrl: './login-reset-password.component.html',
	styleUrls: ['./login-reset-password.component.scss'],
})
export class LoginResetPasswordComponent implements OnInit {
	public newPassword: string;
	public newPasswordAgain: string;
	public resetPasswordErrorMessage: string;

	public passwordReset: boolean;
	public resetPasswordLinkSeemsValid: boolean;
	public passwordResetLinkChecked = false;

	private resetPasswordHash: string;
	private resetPasswordUsername: string;

	constructor(
		private authenticationService: AuthenticationService,
		private locationService: LocationService,
		private router: Router,
		private translate: TranslateService
	) { }

	ngOnInit() {
		this.authenticationService.logout(false).subscribe(() => {
			// make sure we are logged out before checking
			this.checkResetPasswordParameters();
		});
	}

	resetPassword() {
		if (this.newPassword && this.newPasswordAgain) {
			if (this.newPassword !== this.newPasswordAgain) {
				this.resetPasswordErrorMessage = this.translate.instant('CHANGE_PASSWORD_MSG_NOT_EQUAL');
			} else if (this.newPassword.trim().length < 8) {
				this.resetPasswordErrorMessage = this.translate.instant('PASSWORD_DOES_NOT_MEET_REQUIREMENTS');
			} else {
				this.authenticationService.loginWithHash(this.resetPasswordUsername, this.resetPasswordHash)
					.pipe(
						catchError((error: any) => {
							this.resetPasswordErrorMessage = this.translate.instant('INVALID_RESET_PASSWORD_LINK');
							throw error;
						})
					)
					.subscribe(() => {
						// logged in with hash
						this.authenticationService.changePasswordByHash(this.resetPasswordHash, this.newPassword).subscribe(() => {
							this.passwordReset = true;
						});
					});
			}
		} else {
			this.resetPasswordErrorMessage = this.translate.instant('CHANGE_PASSWORD_MSG_EMPTY_FIELDS');
		}
	}

	logout() {
		this.authenticationService.logout().subscribe();
	}

	private checkResetPasswordParameters() {
		if (this.router.url.indexOf('reset-password') > -1) {
			this.resetPasswordHash = this.locationService.getParam('h') ? this.locationService.getParam('h').values.join(',') : '';
			this.resetPasswordUsername = this.locationService.getParam('u') ? this.locationService.getParam('u').values.join(',') : '';

			if (
				typeof this.resetPasswordHash === 'string' && this.resetPasswordHash.length > 0
				&& typeof this.resetPasswordUsername === 'string' && this.resetPasswordUsername.length > 0
			) {

				this.authenticationService.loginWithHash(this.resetPasswordUsername, this.resetPasswordHash)
					.pipe(
						catchError((error: any) => {
							this.resetPasswordLinkSeemsValid = false;
							this.passwordResetLinkChecked = true;
							throw error;
						})
					)
					.subscribe(() => {
						this.resetPasswordLinkSeemsValid = true;
						this.passwordResetLinkChecked = true;
					});
			} else {
				this.resetPasswordLinkSeemsValid = false;
				this.passwordResetLinkChecked = true;
			}
		}
	}
}
